<template>
  <div :class="['item_list',detailData.gridWrapClassName]" :style="boxStyle">
    <div v-for="(item, index) in detailData.content.imgList" :key="index" class="floatimg-item" :class="{'bg':!item.src}">
        <img v-if="item.src" class="floatimg-image" :src="item.imgSrc" />
        <img class="play_btn" v-if="item.actionType == 10" :src="`${fixImg}minipro/play.png`" />
    </div>
  </div>
</template>

<script>

import mixins from '../mixins/mixins'
export default {
  name: 'FloatImg',
  props: {
  },
  components: {},
  mixins: [mixins],
  data() {
    return {
      detailData: {
        content: {
          imgList: []
        }
      },
      pattern: {},
    }
  },
  watch: {
  },
  computed: {
    boxStyle(){
      let str = `margin-left:${(this.pattern.margin || 0)}px;margin-right:${(this.pattern.margin || 0)}px;`
      if(this.detailData.girdStyle){
        str += this.detailData.girdStyle
      }
      return str
    },
  },
  methods: {
    async init() {
      this.detailData = await this._filter(this.itemData)
      this.pattern = this.detailData.pattern || {}
      console.log("FloatImg----------this.detailData");
      console.log(this.detailData);
    },
  },
  async mounted() {
    
  }
}
</script>
<style lang="scss" scoped>
    .item_list{
        .floatimg-item{
            // display: flex;
            // justify-content: center;
            // align-items: center;
            position: relative;
            &.bg{
              height: 0;
              padding-top: 100%;
              background-image: url("../image/imgDefault.png");
              background-size: 100% 100%;
              background-repeat: no-repeat;
            }
            .floatimg-image{
                width: 100%;
                height: 100%;
            }
            .play_btn {
                position: absolute;
                width: 44px;
                height: 44px;
                top: 50%;
                left: 50%;
                transform: translate(-50%,-50%);
                z-index: 2;
            }
        }
        &.grid-view__2,
        &.grid-view__4,
        &.grid-view__6,
        &.grid-view__8 {
            .floatimg-item:nth-child(odd) {
                overflow: hidden;
                .floatimg-image {
                    width: 101%;
                }
            }
        }
    }
    .item_list {
        width: 100%;
        display: grid;
    }
</style>
